// extracted by mini-css-extract-plugin
module.exports = {"icon":"BaseIcon_icon__138pT","default-fill":"BaseIcon_default-fill__1jNIw"};